export enum SortBy {
	Asc = 'asc',
	Desc = 'desc',
}

export interface SortArrowsProps {
	sortBy: SortBy;
	isSortByActive: boolean;
}
